import { Controller } from "@hotwired/stimulus"

// Progressively enhances a native <select> with the theme's virtual-select
// plugin while keeping the original <select> as the source of truth for
// form submission and any other listeners (data-action="change->...").
export default class extends Controller {
  connect() {
    this.select = this.element
    this.select.classList.add("d-none")

    this.mount = document.createElement("div")
    this.select.insertAdjacentElement("afterend", this.mount)

    this.onChange = this.onChange.bind(this)
    this.mount.addEventListener("change", this.onChange)

    this.init()
  }

  disconnect() {
    this.mount?.removeEventListener("change", this.onChange)
    this.mount?.remove()
    this.select.classList.remove("d-none")
  }

  init() {
    const select = this.select
    const groups = select.querySelectorAll("optgroup")
    const hasOptionGroup = groups.length > 0

    let options
    let totalCount

    if (hasOptionGroup) {
      options = Array.from(groups).map((group) => ({
        label: group.label,
        options: Array.from(group.querySelectorAll("option")).map((option) => ({
          label: option.textContent.trim(),
          value: option.value
        }))
      }))
      totalCount = options.reduce((sum, group) => sum + group.options.length, 0)
    } else {
      options = Array.from(select.options).map((option) => ({
        label: option.textContent.trim(),
        value: option.value
      }))
      totalCount = options.length
    }

    const selectedValue = select.multiple
      ? Array.from(select.selectedOptions).map((option) => option.value)
      : select.value

    window.VirtualSelect.init({
      ele: this.mount,
      options,
      hasOptionGroup,
      multiple: select.multiple,
      selectedValue,
      search: totalCount > 6,
      placeholder: select.dataset.placeholder || "Select",
      disableClearButton: select.required,
      noOfDisplayValues: 4
    })
  }

  onChange() {
    const value = this.mount.value

    if (this.select.multiple) {
      const values = Array.isArray(value) ? value : value ? [ value ] : []
      Array.from(this.select.options).forEach((option) => {
        option.selected = values.includes(option.value)
      })
    } else {
      this.select.value = value
    }

    this.select.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
